// extracted by mini-css-extract-plugin
module.exports = {"root":"pfOYCfXb","title":"salk_W_g","description":"KA41_Bgt"};